import { useEffect, useState } from 'react'

import type { CookieConsent } from '../../utils/cookieConsent'
import { readCookieConsent, subscribeCookieConsent } from '../../utils/cookieConsent'
import { initGtm } from '../../utils/gtm'

export const GoogleTagManager = () => {
    const [consent, setConsent] = useState<CookieConsent | null>(null)

    useEffect(() => {
        setConsent(readCookieConsent())
        return subscribeCookieConsent(setConsent)
    }, [])

    useEffect(() => {
        if (consent === 'accepted') initGtm()
    }, [consent])

    return null
}
